import { FC } from "react";

import { IconProps, initializeSvgIconProps } from "mds/utils/images";

export const CircleExclamationFilledIcon: FC<IconProps> = (props) => (
  <svg {...initializeSvgIconProps(props)}>
    <path
      d="M8 0.832031C11.9579 0.832207 15.166 4.04304 15.166 8.00098C15.1653 11.9583 11.9575 15.1668 8 15.167C4.04262 15.1667 0.833711 11.9583 0.833008 8.00098C0.833008 4.0431 4.04218 0.832295 8 0.832031Z"
      fill="currentColor"
    />
    <path
      d="M8 10.042C7.65493 10.0421 7.375 10.3219 7.375 10.667C7.37553 11.0116 7.65526 11.2919 8 11.292H8.00684C8.35161 11.2919 8.63131 11.0117 8.63184 10.667C8.63184 10.3219 8.35194 10.0421 8.00684 10.042H8ZM8 4.70898C7.65493 4.70912 7.375 4.98889 7.375 5.33398V8.00098C7.3757 8.34548 7.65537 8.62584 8 8.62598C8.34474 8.62598 8.6243 8.34556 8.625 8.00098V5.33398C8.625 4.98881 8.34518 4.70898 8 4.70898Z"
      fill="white"
    />
  </svg>
);
